import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';
import { DEFAULT_LANG_CODE } from 'app/utils/supportedLanguages';
import { withTemplates } from 'hocs';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { conversationFormActions } from '../../../../conversation/actions/conversationForm';
import { getCurrentConversationLanguage } from '../../../../conversation/selectors';
import * as personalActions from '../../../../settings/actions/personal';
import { hasFeature } from '../../../featureFlag';
import { richTextFieldActions } from '../actions/richTextField';
import RichTextField from '../components/RichTextField';
const { personalSubmitMessageWithEnter } = personalActions.actions;
const mapStateToProps = (state) => {
    return {
        isAttachmentsUploading: state.conversationForm.meta.addAttachments === 'loading',
        submitMessageWithEnter: state.settings.personal.submitMessageWithEnter,
        hasNewKeybindings: hasFeature(state, 'new-keybindings'),
        hasFFWriteHTMLEmail: hasFeature(state, 'write-html-email'),
        hasLanguageTranslationControlFF: hasFeature(state, 'templates-language-translation-control'),
        language: getCurrentConversationLanguage(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        arrayPush: (form, field, value) => dispatch(arrayPush(form, field, value)),
        personalSubmitMessageWithEnter: bindActionToPromise(dispatch, personalSubmitMessageWithEnter),
        conversationFormAddAttachments: bindActionToPromise(dispatch, conversationFormActions.conversationFormAddAttachments),
        richTextFieldAddAttachments: bindActionToPromise(dispatch, richTextFieldActions.richTextFieldAddAttachments),
    };
};
const templateNormalizer = (template, params) => {
    var _a, _b, _c, _d, _e;
    const locale = params.locale_translations || DEFAULT_LANG_CODE;
    const defaultSubject = (_a = template.subject) !== null && _a !== void 0 ? _a : '';
    return {
        name: template.name,
        subject: locale === DEFAULT_LANG_CODE
            ? defaultSubject
            : ((_c = (_b = template.translations) === null || _b === void 0 ? void 0 : _b[locale]) === null || _c === void 0 ? void 0 : _c.subject) || defaultSubject,
        content: locale === DEFAULT_LANG_CODE
            ? template.content
            : ((_e = (_d = template.translations) === null || _d === void 0 ? void 0 : _d[locale]) === null || _e === void 0 ? void 0 : _e.content) || template.content, // Fallback to template content if there is no translation for content,
    };
};
const ConnectedRichTextField = connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(RichTextField);
export default withTemplates(ConnectedRichTextField, {
    infinite: true,
    itemNormalizer: templateNormalizer,
    initialParams: {
        type: 'quick_response',
        sort_by: 'name:asc',
    },
});
